<template>
  <div class="card">
    <div class="card-header">
      <div class="bolder-title"> Ответы <i class="bi bi-info"></i></div>
        <date-picker v-model="date"
                   locale="ru"
                   :clearable="false"
                   format="dd.MM.yyyy"
                   model-type="yyyy-MM-dd"
                   auto-apply
                   :enable-time-picker="false"></date-picker>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col">
          <div class="graph">
            <div class="total-count">
              <div class="value">{{ totalReview }}</div>
              <div class="sub-text">Ответов</div>
            </div>
            <Doughnut :data="data_doughnut" :options="{
  responsive: true,
  maintainAspectRatio: false,
   plugins: {
          htmlLegend: {
            containerID: 'legend-container-1',
          },
          legend: {
            display: false,
          },
          datalabels: {
            formatter: function (value, context) {
              return '';
            }
          }
        }
}
"/>
          </div>
        </div>
        <div class="col">

          <div id="legend-container-1" class="legend">
            <ul class="resource-list">

          <template v-for="(resource, index) in resources" >
              <li v-if="(!showed && index <= 5) || showed">
                <div class="name">
                  <div class="resource-checkbox">
                    <input type="checkbox" name="" :id="`answer-stat-${resource.resource_id}`" v-model="resource.check">
                    <label :for="`answer-stat-${resource.resource_id}`">
                      <span :style="{backgroundColor: resource.color, borderColor: resource.color}"
                            class="check"><i class="bi bi-check"></i></span>
                      {{ resource.name || resource.domain }}</label>
                  </div>
                </div>
                <div class="values">
                  <div class="percent">{{ resource.response_rate }}%</div>
                  <div class="value">{{ resource.total_responses }}</div>
                </div>
              </li>
            </template>
              <li>
                <button class="btn btn-sm btn-show-all" v-if="resources.length >5" @click="showed=!showed">
                  <template v-if="showed">Скрыть</template>
                  <template v-else>Посмотреть все</template>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>

import {Doughnut} from "vue-chartjs";
import moment from 'moment';
import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement} from 'chart.js'
import {ReviewApi} from "@/api/reviews";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement)

ChartJS.defaults.plugins.legend.display = false;

export default {
  name: 'AnswerStat',
  components: {Doughnut},
  props: {},
  data() {
    return {
      date: moment().format("YYYY-MM-DD"),
      showed: false,
      resources: []
    }
  },
  watch: {
    date(){
      this.getData();
    }
  },
  mounted: function () {
    this.getData();
  },
  computed: {
    totalReview() {
      return this.resources.filter(x => x.check === true).map(x => x.total_responses ? x.total_responses : 0).reduce((a, c) => a + c, 0).toLocaleString('en-US', {minimumFractionDigits: 0});
    },
    data_doughnut() {

      let dataset = {
        backgroundColor: [],
        data: []
      }, labels = [];
      this.resources.filter(x => x.check === true).forEach(resource => {
        labels.push(resource.name || resource.domain)
        dataset.backgroundColor.push(resource.color)
        dataset.data.push(resource.total_responses)
      })
      return {labels: labels, datasets: [dataset]};
    },
  },

  methods: {
    getData(){
      ReviewApi.answer_stat(this.date).then(response => {
      this.resources = response
      this.resources.map((x, index) => {
        if (!x.color) x.color = this.getRandomColor()
        if (index < 6) x.check = true
      })
    })
    },
    getRandomColor() {
      return `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
    }
  }
}

</script>
<style scoped lang="scss">
.graph {
  width: 180px;
  height: 180px;
  position: relative;

  .total-count {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    text-align: center;

    .value {
      font-size: 24px;
      font-weight: 700;
    }

    .sub-text {
      color: rgba(108, 110, 121, 1);
      font-size: 12px;
      font-weight: 400;
    }
  }
}

.resource-list {
  flex-direction: column;
  width: 100%;
  gap: 10px;
  padding-left: 0;

  li {
    display: flex;
    gap: 10px;
    justify-content: space-between;

    .values {
      display: flex;
      gap: 10px;
      text-align: right;

      .percent {
        color: rgba(108, 110, 121, 1);
      }
    }
  }
}

.btn-show-all {
  height: 28px;
  background: rgba(138, 142, 155, 0.1);
  border: 1px solid rgba(196, 199, 207, 1);
  font-size: 14px;
  font-weight: 500;
  color: rgba(108, 110, 121, 1);
  display: flex;
  align-items: center;

  &.bg-secondary {
    font-size: 10px;
    font-weight: 500;
    padding: 2px 4px;
    line-height: 10px;
    background: rgba(138, 142, 155, 1);
  }
}
</style>

